import React, { ReactNode } from 'react';
import closeIcon from './close.svg';
import { Button } from '@airdao/ui-library';

interface IModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  header: string;
  actionTitle: string;
  action: () => void;
  content: ReactNode;
  isLoading?: boolean;
}
const Modal = ({
  isOpen,
  setIsOpen,
  header,
  actionTitle,
  action,
  content,
  isLoading,
}: IModalProps) => {
  return (
    <>
      {isOpen && (
        <>
          <div className="modal" onClick={() => setIsOpen(false)} />
          <div className={'modal__container'}>
            <div className={'modal__wrapper'}>
              <div className={'modal__header'}>
                <p className={'modal__header__title'}>{header}</p>
                <button
                  className={'modal__header__close'}
                  onClick={() => setIsOpen(false)}
                >
                  <img src={closeIcon} alt="close" />
                </button>
              </div>
              <div className={'modal__content'}>{content}</div>
              <Button className="modal__button" size="large" type='primary' onClick={action} disabled={isLoading}>
                {actionTitle}
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
